export const RESTAURANT_TYPES = {
  REGULAR: "REGULAR",
  GUIDE: "GUIDE",
  PREGUIDE: "PREGUIDE",
  DRAFT: "DRAFT",
  ALL: "ALL",
};

// Guide restaurants: the published ones and the ones still being built. Both
// carry productImages -- in fact PREGUIDE is where most of them live.
export const GUIDE_RESTAURANT_TYPES = [
  RESTAURANT_TYPES.GUIDE,
  RESTAURANT_TYPES.PREGUIDE,
];
